import React from 'react';

export default class extends React.Component<{ className?: string }> {
  static displayName = 'preloader';

  render() {
    return <div className={`circle-preloader ${this.props.className || ''}`} />;
  }
}
